const appConfig = {
	theme_color: 'hsl(131, 41%, 47%)',
	features: {
		loginAfterRegistration: false,
		loginAfterResetPassword: true,
		wishlist: false,
	},
	url_dev: 'http://localhost:3000',
	url_dev_api: 'https://localhost',
  url_prod: 'https://m-und-a-sola.de',
	currency: 'EUR',
	currencySign: '€',
	tax: 19,
	shipping: 500,
  free_shipping: 400000,
	shipping_const: 500,
	lowest_price_before_discount_days: 30,
	default_payment_method: 'advancePayment',
	default_stripe_payment_method_type: 'card',
	payments: {
		stripe: {
			return_url: '$1/$2/pay/success?payment_id=$3&order_id=$4',
		},
		paypal: {
			return_url: '$1/$2/pay/success?payment_id=$3&order_id=$4',
			cancel_url: '$1/$2/pay/cancel?payment_id=$3&order_id=$4',
			mode: 'sandbox', //sandbox or live
		},
	},
	legal: {
    company: 'M&A Solar',
    street: 'Wiener Straße 1',
    country: 'Deutschland',
    state: 'Niedersachsen',
    country_2_digits: 'D',
    postcode: '38112',
    city: 'Braunschweig',
    manager: 'Mehmet Baydar',
    phone: '00491751689984',
    phone_label: '+49-(0) 175 1689984',
    email: 'info@m-und-a-solar.de',
    web: 'm-und-a-solar.de',
    bank: 'Solaris',
    iban: 'DE19 1101 0101 5713 0479 51',
    bic: ' SOBKDEB2XXX',
    tax_id: 'DE351866446',
    commercial_register: 'Amtsgericht Braunschweig HRA 202814',
    email_retouren: 'refund@m-und-a-solar.de',
	},
	seo: {
    'title': 'M&A Solar',
    'description': 'M&A Solar Ecommerce',
    'openGraph': {
      'title': 'M&A Solar',
      'description': 'M&A Solar Ecommerce',
      'type': 'website',
      'url': 'https://m-und-a-solar.de',
      'site_name': 'M&A Solar',
      'images': [
        {
          'url': '/pwa/logo.png',
          'width': '800',
          'height': '600',
          'alt': 'M&A Solar'
        }
      ]
		},
		twitter: {
			site: '@m-und-a-solar',
			creator: '@m-und-a-solar',
			card: 'summary',
			title: 'm und a solar',
			description: 'm-und-a-solar',
			image: 'https://m-und-a-solar.de/pwa/logo/logo_color_text.png',
		},
		revisit_after: '15 days',
		copyright_year: '2023',
	},
}

export { appConfig }
